import SENTRY from 'config/sentry.singleton';
import OLD_ERRORS from 'constants/messages/oldErrors.const';
import { FeStack } from 'errors/fe.error';
import { locationReload } from 'utils/dom/location.util';
import logger from 'utils/logger.util';

const CTAG = 'translateErrorOld';
const L = logger(CTAG);

const USE_SENTRY = false;

// DEPRECATED: use fromAnyToMessageV1 or similar
// SEE: src/utils/converters/messages
const translateErrorOld = (key, context) => {
  // when online booking and ui.salon open at the same time, logout ui.salon would get an error:
  // Cannot read properties of null (reading 'signInUserSession'), this will trigger the Unknown error
  // if ignored, it will cause an error in https://getslick.atlassian.net/browse/GS-9637
  // so when signInUserSession issue occur, we do a re-load to get rid of the error to fix GS-9637
  const signInUserSessionIndex = key.indexOf('signInUserSession');
  if (signInUserSessionIndex >= 0) {
    L.warn('()', 'signInUserSessionIndex:', signInUserSessionIndex, 'key:', key, 'Reloading...');
    locationReload(new FeStack({ tag: `translateErrorOld__sign-in-user-session-index--${signInUserSessionIndex}` }));
  }

  if (OLD_ERRORS[key]) return OLD_ERRORS[key];

  if (USE_SENTRY) {
    return SENTRY.info({
      logger: CTAG,
      tags: { key },
      extra: { errorCode: key, context },
      message: `Untranslated Error - ${key}`,
    });
  }

  return OLD_ERRORS.Unknown;
};

export default translateErrorOld;
